module.exports = __webpack_public_path__ + "img/RadioCheck.b5efd00a.svg";